var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_vm.isShownNotification ? _c('div', {
    class: _vm.$style.notification
  }, [_c('cabinet-notification')], 1) : _vm._e(), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('screen-header', {
          attrs: {
            "title": _vm.$t('card.binding.title'),
            "history-mode": false
          },
          on: {
            "navigate": _vm.handleNavigate
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": _vm.handleNavigate
          }
        }), _c('screen-title', {
          attrs: {
            "title": _vm.$t('card.binding.title')
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('h3', {
    class: _vm.$style.title
  }, [_vm._v(" " + _vm._s(_vm.$t('card.binding.form.title')) + " ")]), _c('div', {
    class: _vm.$style.form
  }, [_c('card-inputs-mix', {
    ref: "CardInputs"
  })], 1), _c('p', {
    class: _vm.$style.text,
    domProps: {
      "innerHTML": _vm._s(_vm.displayCardBindingPrivacyPolicy)
    }
  })]), _c('div', {
    class: _vm.$style.submit
  }, [_c('simple-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('card.binding.submit')) + " ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }